import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import store from "./store";
import history from "./history";
import Layouts from "./layouts";
import { THEME_CONFIG } from "./configs/AppConfig";
import { ToastContainer } from "react-toastify";
import dayjs from "dayjs";
import { isProduction } from "utils/environment";

import {
  useQuery,
  useMutation,
  useQueryClient,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";

import "dayjs/locale/es-mx";
import "react-medium-image-zoom/dist/styles.css";

import "./lang";
import "./index.css";

dayjs.locale("es-mx");

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

const queryClient = new QueryClient();

function App() {
  return (
    <div className="App">
      <ToastContainer />
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <BrowserRouter
            basename={isProduction() ? "/panel" : undefined}
            history={history}
          >
            <ThemeSwitcherProvider
              themeMap={themes}
              defaultTheme={THEME_CONFIG.currentTheme}
              insertionPoint="styles-insertion-point"
            >
              <Layouts />
            </ThemeSwitcherProvider>
          </BrowserRouter>
        </Provider>
      </QueryClientProvider>
    </div>
  );
}

export default App;
